var _style, _circle, _circle2, _path, _circle3, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUbuntu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#ea4f06}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 72.6,
    cy: 242,
    r: 72.6,
    className: "st0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 374.9,
    cy: 82.8,
    r: 72.6,
    className: "st0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.8 343c36.6 92.2 126.4 152.2 225.6 150.5-14.2-17.8-22-39.8-22.3-62.6-6.5-.9-12.7-2-18.7-3.2-52.1-11-96.3-45.1-120.2-92.6-20 9.5-42.6 12.3-64.4 7.9",
    className: "st0"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.6,
    cy: 429.2,
    r: 72.6,
    className: "st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M423.4 348.3c17.7 14.2 30.3 33.8 35.8 55.9 65.7-81.4 70.6-196.1 12.2-282.8-8.3 20.6-23 38-42 49.5 30 56 27.7 123.7-6 177.4M72.8 138.6c7.2 0 14.4.7 21.5 2.2 12 2.6 23.4 7.2 33.7 13.8 32.4-47.2 85.8-75.8 143-76.5.2-5.7.9-11.4 2-17 3.5-16 10.6-31 20.9-43.7-93.5-7.5-182.8 39.9-228.8 121.5 2.6-.2 5.1-.3 7.7-.3",
    className: "st0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbuntu);
export default __webpack_public_path__ + "static/media/ubuntu.f89c73ece5282145122ea0840ea70fce.svg";
export { ForwardRef as ReactComponent };